import React from 'react';
import { Navbar } from '../components/Navbar';
import { ConsularAffairs } from '../components/ConsularAffairs';
import { Footer } from '../components/Footer';
import { FeedbackPopup } from '../components/FeedbackPopup';
export function ConsularPage() {
  return <div className="font-nunito w-full min-h-screen overflow-x-hidden" data-id="element-2276">
      <Navbar data-id="element-2277" />
      <main data-id="element-2278">
        <ConsularAffairs data-id="element-2279" />
      </main>
      <Footer data-id="element-2280" />
      <FeedbackPopup data-id="element-2281" />
    </div>;
}